module.exports = __webpack_public_path__ + "media/organizations/zalando-95e20a56.svg";